import { render, staticRenderFns } from "./Batchtaxcopying.vue?vue&type=template&id=2cfc04cc&scoped=true&"
import script from "./Batchtaxcopying.vue?vue&type=script&lang=js&"
export * from "./Batchtaxcopying.vue?vue&type=script&lang=js&"
import style0 from "./Batchtaxcopying.vue?vue&type=style&index=0&id=2cfc04cc&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc04cc",
  null
  
)

export default component.exports